module.exports = __webpack_public_path__ + "static/media/DINPro-Bold_13934.05078759.ttf";